
import { ContentType } from "@/api/scode/scode_params";
import { uiStore } from "@/components/tab-bar";
import { getRatio } from "@/utils/pxtorem";
import { setH5ShareCardInfo } from "@/utils/share/common";
import { ProductModel } from "@akc/biz-api";
import { throttle } from "lodash";
import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import PrdVideoCardListCore, { PrdVideoCardListCoreRef } from "../PrdVideoCardListCore";

export interface VideoCardListRef {
  // 拉起当前视频商品的转发海报
  // showPoster: () => void;
}

const getSafeAreaBottomValue = () => {
  const rootStyle = window.getComputedStyle(document.documentElement);
  const value = parseFloat(rootStyle.getPropertyValue("--safe-area-inset-bottom"));
  return isNaN(value) ? 0 : value;
};
/**
 * 逛一逛，推荐tab的视频列表组件
 * 注意和/Users/mengxiang/codes/H5/mx-shop-micro/src/pages/product-detail/video-card-list/index.tsx的区别
 */
const VideoCardList = forwardRef<VideoCardListRef, { isBackground?: boolean }>(
  ({ isBackground }, ref) => {

    // tabbar本身是50， 考虑到边界 过于分明， 所以减去3
    const tabbarHeightRef = useRef(47 * getRatio() + getSafeAreaBottomValue());

    const [screenHeight, setScreenHeight] = useState(
      document.documentElement.clientHeight - tabbarHeightRef.current,
    );

    const currentProductRef = useRef<ProductModel | null>(null);
    const prdVideoCardListCoreRef = React.useRef<PrdVideoCardListCoreRef>(null);
  //分享使用的扩展字段
  const shareContentExtra=useMemo(() => {
    return {
      pageName: "/mx-shop-micro/video-card-list",//用于分享的页面名称，用于分享后的踩链定位
      showVideoBtmGuide:  "",
      showVideoBottomBar: "",
      hideForwardBtn: "",
      theme:  "",
      materialNo:""
    };
  }, []);


    useEffect(() => {
      // 节流
      const handleResize = throttle(() => {
        tabbarHeightRef.current = 47 * getRatio() + getSafeAreaBottomValue();
        setScreenHeight(document.documentElement.clientHeight - tabbarHeightRef.current);
      }, 200);

      window.addEventListener("resize", handleResize);
      // H5 页面可见性变化的时候，也需要重新计算
      document.addEventListener("visibilitychange", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
        document.removeEventListener("visibilitychange", handleResize);
      };
    }, []);

    // 拉起海报时，隐藏tabbar
    const onPosterVisibleChange = (posterVisible: boolean) => {
      uiStore.setTabbarVisible(!posterVisible);
    };


    // useImperativeHandle(ref, () => ({
    //   showPoster:() => {
    //     prdVideoCardListCoreRef.current?.showPoster();
    //   },
    // }));

    /**
     * 视频索引改变
     * 注：如果需要配置系统分享则要用到（暂无实现逻辑），系统分享公共方法是shareCardByH5
     * @param product 
     * @param index 
     * @param requestId 
     */
    const handleIndexChange = (product: ProductModel) => {
      if(product?.activityId && product?.activityId===currentProductRef.current?.activityId) {
        return;
      }
      currentProductRef.current = product;
      setH5ShareCardInfo({
        contentType: ContentType.spuProduct,
        contentId: product.activitySpuId ?? "",
        contentDetailId: product.selectSkuId ?? "",
        contentTypeConfig: "1",
        contentExtra: {
          ...(shareContentExtra || {}),
          materialNo: product?.productVideoCardVO?.materialNo || "",
        },
        posterInfo: {},
        page_name: "种草社区_推荐",
      });
    };




    return (
      <div>
        <PrdVideoCardListCore
          ref={prdVideoCardListCoreRef}
          isBackground={isBackground}
          vcScene="personVideoCard"
          showVideoBtmGuide={false}
          hideForwardBtn={false}
          theme="dark"
          trackDataCommon={{
            page_name: "种草社区_推荐",
            domain: "种草",
            tab_name: "推荐",
          }}
          shareContentExtra={shareContentExtra}
          swiperHeight={`${screenHeight}px`}
          onIndexChange={handleIndexChange}
          onPosterVisibleChange={onPosterVisibleChange}
        />
      </div>
    );
  },
);

export default VideoCardList;
